export const badgeVariantStyles = {
  success: {
    bgColor: "#E7F1E8", // 009f101a
    textColor: "#000000",
    dotColor: "#009F10",
  },
  pending: {
    bgColor: "#FFF7E6",
    textColor: "#000000",
    dotColor: "#FFA500",
  },
  danger: {
    bgColor: "#FDECEC",
    textColor: "#000000",
    dotColor: "#FF0000",
  },
  primary: {
    bgColor: "#a3343424",
    textColor: "#A33434",
    dotColor: "#A33434",
  },
  blue: {
    bgColor: "#ADD8E6",
    textColor: "#000000",
    dotColor: "#0077B6",
  },
  greyStock: {
    bgColor: "#607d8b26",
    textColor: "#000000",
    dotColor: "#607D8B",
  },
  makeToOrder: {
    bgColor: "#ffb32e1a",
    textColor: "#000000",
    dotColor: "#FFB32E",
  },
};

export const CustomDot = ({ color, size = 7, className }) => {
  return (
    <span
      className={`block rounded-full border-gray-300 ${className}`}
      style={{
        backgroundColor: color,
        width: `${size}px`,
        height: `${size}px`,
        minWidth: `${size}px`,
        minHeight: `${size}px`,
      }}
    />
  );
};

const CustomBadge = ({ variant = "success", text, customColors, divClassName, dotClassName }) => {
  const { bgColor: customBg, textColor: customText, dotColor: customDot } = customColors || {};
  const { bgColor: variantBg, textColor: variantText, dotColor: variantDot } = badgeVariantStyles[variant] || badgeVariantStyles.success;
  const finalBg = customBg || variantBg;
  const finalText = customText || variantText;
  const finalDot = customDot || variantDot;

  if (!text) {
    return null;
  }

  return (
    <div
      className={`inline-flex items-center px-3 py-1 text-sm font-bold rounded-lg whitespace-nowrap ${divClassName}`}
      style={{ backgroundColor: finalBg, color: finalText }}
    >
      <CustomDot color={finalDot} className={`mr-2 ${dotClassName}`} />
      {text}
    </div>
  );
};

export default CustomBadge;
